<template>
  <carousel
    class="materia-carousel"
    :navigationEnabled="false"
    :per-page="3"
    :pagination-enabled="false"
    :loop="true"
    :autoplay="true"
    :autoplay-timeout="5000"
    navigationNextLabel='<img  class="pass_d" src="/img/direita-rosa.png" />'
    navigationPrevLabel='<img  class="pass_e" src="/img/esquerda-rosa.png" />'
  >
    <slide v-for="(item, index) in items" :key="index">
      <div class="bloco1">
        <div
          class="banner_materia"
          :style="'background-image: url(' + item.image + ')'"
        ></div>
        <div class="infos">
          <h3 class="titulo-materia">
            {{ item.name }}
          </h3>
          <p class="descricao-materia">
            {{ item.lead }}
          </p>
        </div>
      </div>
      <div class="bloco2">
        <div
          class="img-autor"
          :style="'background-image: url(' + banner2 + ')'"
        ></div>
        <p class="autor-materia">Mari maldos</p>
     
          <button>
            <p>Ler mais</p>
            <img src="img/seta-blog.png" />
          </button>
      
      </div>
    </slide>
  </carousel>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  props: ["items"],
  data() {
    return {
      width: screen.width,
      banner1: "http://localhost/img/DOBRA.png",
      banner2: "http://localhost/img/camila.png",
    };
  },
  components: {
    Carousel,
    Slide,
  },
  methods: {
    navigateTo(index) {
      this.slider = index;
      this.$refs.carouselSelector.goToPage(index);
    },
  },
  mounted() {
    setTimeout(() => {
      this.$refs["carouselSelector"].onResize();
      this.$refs["carouselSelector"].goToPage(0);
    }, 200);
  },
};
</script>

<style lang="scss" rel="stylesheet" media="all">
@import "resources/assets/sass/website/_variables.scss";
.materia-carousel {
  display: flex;
  flex-direction: column;
  .bloco1 {
    border-bottom: 0.5px solid #747474;
    padding-bottom: 10px;
    width: 330px;
    .banner_materia {
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 10px;
      width: 330px;
      height: 210px;
    }
    .titulo-materia {
      color: $pink;
      font-family: $font-inter;
      font-weight: 600;
      font-size: 18px;
      margin-top: 20px;
      word-break: break-word;
      min-height: 65px;
    }
    .descricao-materia {
      color: #747474;
      font-family: $font-inter;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      margin-top: 10px;
      word-break: break-word;
      min-height: 100px;
    }
  }
  .bloco2 {
    align-items: center;
    display: flex;
    flex-direction: row;
    margin-top: 10px;
    position: relative;
    height: 60px;
    width: 330px;
    .img-autor {
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 50%;
      height: 40px;
      width: 40px;
    }
    .autor-materia {
      color: #747474;
      font-family: $font-inter;
      font-style: normal;
      font-weight: 600;
      font-size: 13px;
      margin-left: 10px;
      margin-top: 10px;
    }
    button {
      align-content: center;
      border-radius: 10px;
      background-color: $pink;
      border: none;
      display: flex;
      flex-direction: row;
      justify-content: center;
      outline: none;
      height: 40px;
      width: 135px;
      position: absolute;
      right: 0px;
      padding: 10px;
      p {
        color: white;
        font-weight: 600;
        font-family: $font-inter;
        font-size: 13px;
        margin-right: 10px;
      }
    }
  }
}
</style>
